import * as styles from './hidden-by-scope-note.css.ts'

export type HiddenByScopeNoteProps = {
  count: number
}

/**
 * Footnote beside a total, naming how many findings the active data scope removed. Shared by the
 * collapsed bar and the funnel so the wording and the separator stay identical.
 *
 * The two totals it annotates count the hidden findings differently, which is deliberate: the
 * collapsed bar's "N of M resolved" keeps them in M so completed work stays credited against the
 * original data set, while the funnel's "Share of total" counts only the rows it draws, since every
 * bar is a share of that number. Design confirmed both readings. The count is the quick view's total
 * without the scope minus its total with it, computed in `useResolutionPanel`.
 */
export const HiddenByScopeNote: React.FC<HiddenByScopeNoteProps> = ({ count }) => {
  if (count <= 0) {
    return null
  }

  return <span className={styles.note}> · {count} hidden by scope</span>
}
